<template>
  <div class="onlineReserve-rule">
    <van-row type="flex" justify="center" class="row-title">
      <van-col span="20" class="col-title">
        <p>在线支付</p>
      </van-col>
    </van-row>
    <van-col span="24">
      <div style="margin-left: 50px;margin-top:50px;">
        <van-image
          width="300"
          height="300"
          fit="cover"
          :src="require('@/assets/images/zxzf.png')"
          class="avatar"
        >
      </van-image>
      </div>
    </van-col>
  </div>
</template>

<script type="text/javascript">

import { getSystemConfig } from '@/api/systemConfig.js'
import { Notify } from 'vant'
export default {
  components: {},
  data() {
    return {
      dJXT_QXMC: '',
      dJXT_LXDH: '',
      checkbox: false,
      checkboxGroup: []
    }
  },
  mounted() {
    this.loadSystemConfig()
  },
  created() {

  },
  methods: {
    loadSystemConfig() {
      getSystemConfig({ key: 'DJXT_QXMC' }).then(response => {
        this.dJXT_QXMC = response.data.value
      })
      getSystemConfig({ key: 'DJXT_LXDH' }).then(response => {
        this.dJXT_LXDH = response.data.value
      })
    },
    confirmRead() {
      const isConfirm = this.checkboxGroup.length
      if (isConfirm === 0) {
        Notify({
          type: 'danger',
          message: '请勾选我已阅读并遵守查询规则！',
          duration: 2000
        })
      } else {
        setTimeout(() => {
          // 跳转在线预约页面
          this.$router.push({
            path: '/query/wfzm'
          })
        }, 100)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.onlineReserve-rule{
  .col-title{
    font-size: 1.8em;
    color: #1279BC;
    font-weight: bold;
    p{
      margin: 30px 0 15px;
      text-align: center;
    }
  }
  .col-common{
    p{
      margin: 0;
      color: #888;
      line-height: 30px;
      span{
        color: red;
      }
    }
  }
  .col-major{
    p{
      color: #000;
      font-weight: bold;
      margin: 20px 0 5px;
    }
  }
  .col-rule{
    .van-cell{
      padding: 20px 10px;
      span{
        font-size: 1.2em;
        color: #777;
        font-weight: 600;
      }
    }
  }
  .col-button{
    padding: 10px 0 30px;
    button{
      width: 100%;
    }
  }
}
</style>
